<template>
  <div class="disposal-progress-box">
    <div class="disposal-progress-inner" ref="disposalProgress">
      <!-- <img class="bg" src="@/assets/refund/refund-detail-bg.png" alt /> -->
      <img class="bg" src="../../../../assets/refund/Bg_pic.png" alt />
      <div class="header">
        <!-- 处于企业角色的反馈操作时显示的处置进度 -->
        <!-- <div
          v-if="userInfo && userInfo.roleList[0] === 'CompanyHandler' && btnlist.includes('FEEDBACK_VERIFY')"
        >
          &&
          <p class="title">{{ '待反馈处置结果' }}</p>
          <p class="content-item">请尽快核实退款情况后反馈处理结果</p>
        </div>-->
        <div>
          <!-- 如果可以判断当前角色，可以先区分当前角色 -->
          <!-- 待响应 -->
          <div>
            <p class="title">{{ data.statusText }}</p>
          </div>
          <div v-if="status === 1">
            <!-- <p class="title">待响应</p> -->
            <!-- <p class="title">{{ data.statusText }}</p> -->
            <p class="content-item">待{{ data.centerName }}响应</p>
          </div>
          <div v-if="status === 10 || status === 20">
            <!-- <p class="title">待受理</p> -->
            <!-- <p class="title">{{ data.statusText }}</p> -->
            <p class="content-item">{{ data.centerName }} <span style="color:#666666;">已响应</span></p>
          </div>
          <!-- 退回后：待重新提交 -->
          <div v-if="status === 11">
            <!-- <p class="title">待重新提交</p> -->
            <!-- <p class="title">{{ data.statusText }}</p> -->
            <p class="content-item">已退回至【退货人】 {{ data.submitUser }}</p>
            <p class="content-item">原因：{{ sendbackReason() }}</p>
          </div>

          <!-- 点击签协议后，待签协议(退货中心) -->
          <div v-if="status === 12 && userInfo && userInfo.roleList[0] == 'CenterHandler'">
            <!-- <p class="title">{{ data.statusText }}</p> -->
            <p class="content-item">{{ data.centerName }} <span style="color: #666666;"></span>处理中...</p>
            <p v-if="protocol" class="content-item">若退货人选择寄存，请与其签订<a class="sign" :href="protocol">《委托存放协议》。</a></p>
            <p v-else class="content-item">若退货人选择寄存，请与其签订<a class="sign" href="javascript:void(0)">《委托存放协议》。</a></p>
          </div>
          <div v-if="status === 13 && userInfo && userInfo.roleList[0] == 'CenterHandler'">
            <!-- <p class="title">{{ data.statusText }}</p> -->
            <template v-if="protocol">
              <p class="content-item">已同退货人签订<a class="sign" :href="protocol">《委托存放协议》</a></p>
              <p class="content-item color666">请及时反馈取货信息</p>
            </template>
            <template v-else>
              <p class="content-item">已同退货人签订<a class="sign" href="javascript:void(0)">《委托存放协议》</a></p>
              <p class="content-item color666">请及时反馈取货信息</p>
            </template>

          </div>

          <div v-if="status === 12 && userInfo && userInfo.roleList[0] == 'Handler'">
            <!-- <p class="content-item">请尽快核实退款情况后反馈处理结果</p> -->
            <p class="content-item">已发起签订<a class="sign" :href="protocol">《委托存放协议》</a></p>
            <p class="content-item">请协调游客尽快签订</p>
            <!-- <p v-if="protocol" class="content-item">若游客选择寄存，请与其签订<a class="sign" :href="protocol">《委托存放协议》。</a></p>
            <p v-else class="content-item">若游客选择寄存，请与其签订<a class="sign" href="javascript:void(0)">《委托存放协议》。</a></p> -->
          </div>
          <div v-if="status === 13 && userInfo && userInfo.roleList[0] == 'Handler'">

            <template v-if="protocol">
              <p class="content-item">已同退货人签订<a class="sign" :href="protocol">《委托存放协议》</a></p>
              <p class="content-item color666">请及时反馈取货信息</p>
            </template>
            <template v-else>
              <p class="content-item">已同退货人签订<a class="sign" href="javascript:void(0)">《委托存放协议》</a></p>
              <p class="content-item color666">请及时反馈取货信息</p>
            </template>
          </div>

          <!-- 下级的上报的待审核 -->
          <div v-if="status === 21">
            <!-- <p class="title">待审核</p> -->
            <!-- <p class="title">{{ data.statusText }}</p> -->
            <p class="content-item">已上报至{{ historyInfo[1].optContent | strFilter }}</p>
            <p class="content-item">原因：{{ historyInfo[1].memo }}</p>
          </div>
          <!-- 上级审核上报 -->
          <div v-if="status === 22 && btnlist.includes('REVIEW')">
            <!-- <p class="title">待审核</p> -->
            <!-- <p class="title">{{ data.statusText }}</p> -->
            <p class="content-item">该退货单由 {{ historyInfo[2].optContent | strFilter5 }} 上报</p>
            <p class="content-item">原因：{{ historyInfo[2].optContent | getReason }}</p>
          </div>
          <!-- 下级的上报待审核中 -->
          <div v-if="status === 22 && !btnlist.includes('REVIEW')">
            <!-- <p class="title">待审核</p> -->
            <!-- <p class="title">{{ data.statusText }}</p> -->
            <p class="content-item">已上报至{{ historyInfo[1].optContent | strFilter4 }}</p>
            <p class="content-item">原因：{{ historyInfo[1].memo }}</p>
          </div>
          <div v-if="status === 29 && userInfo && userInfo.roleList[0] === 'CompanyHandler'">
            <!-- <p class="title">待审核</p> -->
            <!-- <p class="title">{{ data.statusText }}</p> -->
            <p class="content-item"> <span class="centerName">{{ data.centerName }}</span><span class="shenhezhong"> 审核中</span></p>
          </div>
          <div
            v-if="status === 29 && userInfo && ['Handler', 'Leader'].includes(userInfo.roleList[0])"
          >
            <!-- <p class="title">待审核</p> -->
            <!-- <p class="title">{{ data.statusText }}</p> -->
            <p class="content-item">{{ data.centerName }}已反馈不予受理</p>
          </div>
          <!-- 同意受理之前的不予受理 -->
          <div v-if="status === 30">
            <!-- <p class="title">{{ data.statusText }}</p> -->
            <p v-if="WHEREFORE && WHEREFORE.length > 0" class="content-item buyushouliyuanyin">原因：{{ getInadmissibleReason(historyInfo) }}</p>
            <!-- <p v-if="timeDifference > 0" class="content-item">若退货人无异议，该退货单将在{{ timeDifference | timeFilter }}后结束受理。请在结束受理后将商品寄回。</p> -->
          </div>
          <div v-if="status === 31">
            <p class="content-item">原因：退货人超时未处理，自动撤销</p>
          </div>
          <div v-if="status === 40">
            <!-- <p class="title">待反馈退货地址</p> -->
            <!-- <p class="title">{{ data.statusText }}</p> -->
            <!-- <p class="content-item">{{ data.centerName }}处理中</p> -->
          </div>
          <div v-if="status === 41 && btnlist.includes('FEEDBACK_EXPRESS')">
            <!-- <p class="title">待上传快递单号</p> -->
            <!-- <p class="title">{{ data.statusText }}</p> -->
            <p class="content-item">
              <span class="fontweight-span color333333">「退货人」{{ data.submitUser }}
              </span>
              <span style=" color: #666666;">处理中...</span>
            </p>
            <p class="content-item color666">若退货⼈无法上传快递单号您也可以代替上传</p>
          </div>
          <div v-if="status === 41 && !btnlist.includes('FEEDBACK_EXPRESS')">
            <!-- <p class="title">待上传快递单号</p> -->
            <!-- <p class="title">{{ data.statusText }}</p> -->
            <p class="content-item">「退货人」 {{ data.submitUser }} <span style="color: #666666;">处理中...</span></p>
          </div>
          <div
            v-if="status === 50 && btnlist.includes('CONFIRM_RECEIPT') && userInfo && userInfo.roleList[0] === 'Handler'"
          >
            <!-- <p class="title">待收货</p> -->
            <!-- <p class="title">{{ data.statusText }}</p> -->
            <p class="content-item" style="color: #666666;">已上传快递单号，请在签收后尽快确认收货</p>
          </div>
          <div
            v-if="status === 50 && !btnlist.includes('CONFIRM_RECEIPT') && userInfo && userInfo.roleList[0] === 'Handler'"
          >
            <!-- <p class="title">待收货</p> -->
            <!-- <p class="title">{{ data.statusText }}</p> -->
            <p class="content-item">{{ data.centerName }} <span style="color: #666666;">处理中</span></p>
          </div>
          <div
            v-if="status === 50 && btnlist.includes('CONFIRM_RECEIPT') && userInfo && userInfo.roleList[0] === 'CompanyHandler'"
          >
            <!-- <p class="title">待收货</p> -->
            <!-- <p class="title">{{ data.statusText }}</p> -->
            <p class="content-item" style="color: #666666;">已上传快递单号，请在签收后尽快确认收货</p>
          </div>
          <div v-if="status === 60 && userInfo && userInfo.roleList[0] === 'CenterHandler'">
            <!-- <p class="title">待反馈处置结果</p> -->
            <!-- <p class="title">{{ data.statusText }}</p> -->
            <p class="content-item">{{ data.centerName }} <span style=" color: #666666;">处理中...</span></p>
          </div>
          <div
            v-if="status === 60 && userInfo && userInfo.roleList[0] === 'Handler' && btnlist.includes('OVERSEE')"
          >
            <!-- <p class="title">待反馈处理结果</p> -->
            <!-- <p class="title">{{ data.statusText }}</p> -->
            <p class="content-item">{{ data.centerName }} <span style=" color: #666666;">处理中...</span></p>
          </div>
          <div
            v-if="status === 60 && userInfo && userInfo.roleList[0] === 'Handler' && !btnlist.includes('OVERSEE') && !btnlist.includes('SIGN') "
          >
            <!-- <p class="title">待反馈处置结果</p> -->
            <!-- <p class="title">{{ data.statusText }}</p> -->
            <p class="content-item" style="color: #666666;">请尽快核实退货情况后反馈处理结果</p>
          </div>

          <div
            v-if="status === 60 && userInfo && userInfo.roleList[0] === 'Handler' && !btnlist.includes('OVERSEE') && btnlist.includes('SIGN') "
          >
            <!-- <p class="title">待反馈处置结果</p> -->
            <!-- <p class="title">{{ data.statusText }}</p> -->
            <p class="content-item">
              <span class="fontweight-span" style="color:#333333;">{{ data.centerName }} </span><span style="color: #666666;">已响应</span> 
            </p>
            <p class="content-item">
              若游客选择寄存，请与其签订
              <a v-if="protocol" class="sign" :href="protocol">《委托存放协议》</a>
              <a v-else class="sign" href="javascript:void(0)">《委托存放协议》</a>
            </p>
          </div>

          <div v-if="status === 60 && userInfo && userInfo.roleList[0] === 'CompanyHandler'">
            <!-- <p class="title">待反馈处置结果</p> -->
            <!-- <p class="title">{{ data.statusText }}</p> -->
            <p class="content-item" style="color: #666666;">请尽快核实退货情况后反馈处理结果</p>
          </div>
          <div v-if="status === 69 && userInfo && userInfo.roleList[0] === 'CompanyHandler'">
            <!-- <p class="title">待审核处置结果</p> -->
            <!-- <p class="title">{{ data.statusText }}</p> -->
            <p class="content-item"> <span class="centerName">{{ typeValue }}</span> <span class="shenhezhong"> 审核中</span></p>
          </div>
          <div v-if="status === 69 && userInfo && userInfo.roleList[0] === 'Handler'">
            <!-- <p class="title">待审核企业处置结果</p> -->
            <!-- <p class="title">{{ data.statusText }}</p> -->
            <p class="content-item">{{ data.centerName }} <span style="color:#666666;">已处置完毕</span></p>
          </div>
          <!-- 已办结 -->
          <div v-if="status === 70 && !btnlist.includes('FEEDBACK_EXPRESS')">
            <!-- <p class="title">{{ data.statusText }}</p> -->
            <p v-if="FeedbackRefundable()" class="content-item">原因：{{ FeedbackRefundable() }}</p>
            <!-- <p v-if="timeDifference > 0 && data.finalRefundTypes === 1" class="content-item">若退货人无异议，请及时将商品退还游客</p> -->
            <!-- <p v-if="timeDifference > 0 && data.finalRefundTypes === 2" class="content-item">若退货人无异议，该退货单将在{{ timeDifference | timeFilter }}后结束受理。</p> -->
            <!-- 如果是邮寄退货时，并且是部分退款且退回商品 -->
            <p v-if="timeDifference > 0 && data.finalRefundTypes === 1 && isReturnGoods()" class="content-item">若退货人无异议，该退货单将在{{ timeDifference | timeFilter }}后结束受理。</p>

          </div>
          <!-- 反馈不予受理后并且倒计时为结束 -->
          <div
            v-if="status === 70 && btnlist.includes('FEEDBACK_EXPRESS') && showFEEDBACKEXPRESSBtn()"
          >
            <!-- <p class="title">不予受理</p> -->
            <!-- <p class="title">{{ data.statusText }}</p> -->
            <p class="content-item">原因：{{ historyInfo[0].optContent | AppealFeedbackContentFilter }}</p>
            <p v-if="timeDifference > 0" class="content-item">若退货人无异议，该退货单将在{{ timeDifference | timeFilter }}后结束受理。请在结束受理后将商品寄回。</p>
          </div>
          <!-- 反馈不予受理后并且倒计时已结束、企业的申诉反馈审核通过后 -->
          <div
            v-if="status === 70 && btnlist.includes('FEEDBACK_EXPRESS') && !showFEEDBACKEXPRESSBtn()"
          >
            <!-- <p class="title">待上传快递单号</p> -->
            <!-- <p class="title">{{ data.statusText }}</p> -->
            <p class="content-item">请将商品原路返回，且在寄出后上传快递单号</p>
          </div>
          <div v-if="status === 80">
            <!-- <p class="title">待收货</p> -->
            <!-- <p class="title">{{ data.statusText }}</p> -->
            <p class="content-item">「退货人」 {{ data.submitUser }} <span style=" color: #666666;">处理中...</span></p>
          </div>
          <!-- 邮寄退货游客确认收货后 -->
          <div v-if="status === 90">
            <div v-if="data.statusText === '不予受理'">
              <p class="content-item">原因：{{ getInadmissibleReason(historyInfo) }}</p>
              <p class="content-item">退货人无异议，服务已结束</p>
            </div>
          </div>
          <!-- 申诉反馈或者申诉反馈不通过回到这里 -->
          <div v-if="status === 97 && btnlist.includes('APPEAL_FEEDBACK')">
            <!-- <p class="title">待反馈申诉处理情况</p> -->
            <!-- <p class="title">{{ data.statusText }}</p> -->
            <!-- 如果没有审核意见表示当前是处于初次反馈 -->
            <p v-if="!appeal.appealFeedbackAuditContent" class="content-item">
              该单由
              <span class="fontweight-span">「退货人」 {{ data.submitUser }}</span>
              发起申诉
            </p>
            <p v-else class="content-item">
              <span class="fontweight-span">{{ data.centerName }}</span>
              审核不通过
            </p>
            <!-- 如果没有审核意见表示当前是处于初次反馈 -->
            <p
              v-if="appeal && !appeal.appealFeedbackAuditContent"
              class="content-item"
            >申诉内容：{{ appeal.appealContent }}</p>
            <p v-else class="content-item">审核意见：{{ appeal.appealFeedbackAuditContent }}</p>
          </div>
          <!-- 企业申诉反馈之后的待审核 -->
          <div v-if="status === 98">
            <!-- <p class="title">待审核申诉反馈</p> -->
            <!-- <p class="title">{{ data.statusText }}</p> -->
          </div>
          <!-- 已评价的未办结 -->
          <div v-if="status === 110">
            <!-- <p class="title">已评价</p> -->
            <!-- <p class="title">{{ data.statusText }}</p> -->
            <!-- <p class="content-item">游客评价：{{ data.paperworkEvaluation | evaluationFilter }}</p> -->
            <p class="content-item">游客评价：{{ getTouristEvaluation() }}
              <img v-if="getEvaluation() === '满意'" src="../../../../assets/refund/manyi.png" alt="">
              <img v-if="getEvaluation() === '基本满意'" src="../../../../assets/refund/jibenmanyi.png" alt="">
              <img v-if="getEvaluation() === '不满意'" src="../../../../assets/refund/bumanyi.png" alt="">
            </p>
          </div>
          <!-- 收回垫付金后 -->
          <div v-if="status === 130">
            <!-- <p class="title">{{ data.statusText }}</p> -->
            <!-- <p class="title">监理中心已回款</p> -->
          </div>
          <div v-if="status === 200 || status === 140">
            <p class="content-item">游客评价：{{ getEvaluation() }}
              <img v-if="getEvaluation() === '满意'" src="../../../../assets/refund/manyi.png" alt="">
              <img v-if="getEvaluation() === '基本满意'" src="../../../../assets/refund/jibenmanyi.png" alt="">
              <img v-if="getEvaluation() === '不满意'" src="../../../../assets/refund/bumanyi.png" alt="">
            </p>
          </div>
          <div v-if="status === 150">
            <!-- <p class="title">已超时</p> -->
            <!-- <p class="title">{{ data.statusText }}</p> -->
            <!-- <p class="content-item">原因：退货人主动撤销（{{ ReasonRevocation() }}）</p> -->
            <p class="content-item">原因：{{ ReasonRevocation() }}</p>
            <p class="content-item">补充说明：{{ cancellationInstructions() }}</p>
          </div>
        </div>
      </div>
      <div class="foot">
        <p @click="checkProgress" class="see-progress">
          查看全部处置进度
          <van-icon size="12" name="arrow" />
        </p>
        <div class="btn-box">
          <div
            v-if="userInfo && userInfo.roleList[0] == 'CenterHandler'"
            class="btn-active"
            @click="contactSupervisionCenter()"
          >联系监理中心</div>
          <!-- 签协议 -->
          <div v-if="btnlist.includes('SIGN')" @click="signAgreement" class="btn">签协议</div>
          <!-- 反馈处置结果 -->
          <div v-if="btnlist.includes('FEEDBACK_VERIFY')" class="btn-active" @click="feedback()">反馈</div>
          <!-- 申诉反馈 -->
          <div
            v-if="btnlist.includes('APPEAL_FEEDBACK')"
            class="btn-active"
            @click="appealFeedback()"
          >反馈</div>
          <!-- 邮寄退货的反馈退货地址 -->
          <div
            v-if="btnlist.includes('FEEDBACK_ADDRESS')"
            class="btn-active"
            @click="feedbackAddress()"
          >反馈</div>
           <!-- 反馈取货信息 -->
           <div
            v-if="btnlist.includes('PICK')"
            class="btn-active"
            @click="feedbackPickupInformation()"
          >反馈</div>
          <!-- <div
            class="btn-active"
            @click="feedbackPickupInformation()"
          >反馈</div> -->
          <!-- 上报审核 -->
          <div v-if="btnlist.includes('REVIEW')" @click="review" class="btn-active">审核</div>
          <!-- 处置结果审核 -->
          <div
            v-if="btnlist.includes('CONCLUDE')"
            @click="disposalResultReview"
            class="btn-active"
          >审核</div>
          <!-- 监理中心审核企业的申诉反馈 -->
          <div
            v-if="btnlist.includes('APPEAL_FEEDBACK_AUDIT')"
            @click="appealFeedbackReview"
            class="btn-active"
          >审核</div>
          <div v-if="data.status == 50" @click="checkLogistics" class="btn">查看物流</div>
          <div v-if="btnlist.includes('CONFIRM_RECEIPT')" @click="receipt" class="btn-active">确认收货</div>
          <div
            v-if="(!showFEEDBACKEXPRESSBtn() && btnlist.includes('FEEDBACK_EXPRESS')) && userInfo && !['leader', 'Leader'].includes(userInfo.roleList[0])"
            @click="UploadTrackingNumber"
            class="btn"
          >上传快递单号</div>


          <div
            v-if="btnlist.includes('COMMENT_DETIAL')"
            @click="evaluationDetails"
            class="btn"
          >评价详情</div>

          <!-- <div
            v-if="btnlist.includes('FEEDBACK_EXPRESS')"
            @click="UploadTrackingNumber"
            class="btn"
          >上传快递单号</div>-->
          <!-- <div class="btn">评价详情</div> -->
        </div>
      </div>
    </div>

    <!-- 监管中心联系人弹出层 -->
    <van-popup
      class="popup"
      v-model="contactPersonShow"
      get-container="body"
      closeable
      :style="{ height: '50%' }"
      position="bottom"
    >
      <p class="title">监理中心联系人</p>
      <div class="contact-list">
        <div v-for="(item, index) in supervisionCenterList" :key="index" class="contact-item">
          <div class="contact-info">
            <!-- <div class="Contact-avatar">
              <img
                src="https://img0.baidu.com/it/u=561041293,259965800&fm=26&fmt=auto&gp=0.jpg"
                alt
              />
            </div>-->
            <div class="business-card">{{ item.name.substr(0, 1) }}</div>
            <div class="person-info">
              <p class="contact-name">{{ item.name }}</p>
              <p class="phone">{{ item.vagueMobile }}</p>
            </div>
          </div>
          <div class="call">
            <a class="call-icon" @click="util.callConfirm('拨打该号码？', item.mobile, 6)" href="javascript:void(0)"></a>
          </div>
        </div>
      </div>
    </van-popup>
    <review ref="review" @sendReview="sendReview"></review>
    <accept ref="accept" @sendAccept="sendAccept"></accept>
  </div>
</template>

<script>
    import api from '../../../../service/modules/refund';
    import review from '../../views/pages/review';
    import accept from '../../views/pages/confirmAccept';
    import util from '../../../../utils/common';
    import Vue from 'vue';
    import { Cell, Dialog } from 'vant';
    Vue.use(Cell);

    export default {
        filters: {
            strFilter3 (val) {
                try {
                    return util.getBracketSt(val)[0].replace(/(【|】)/g, '')
                } catch (err) {
                    alert(err);
                }
            },
            strFilter4 (val) {
               return val.substring(0, val.length - 2)
            },
            // 申诉反馈内容过滤
            AppealFeedbackContentFilter (val) {
                const strArr = val.split(' ');
                return strArr[1];
            },
            // 时间戳转换
            timeFilter (val) {
                return util.getStampInDate4(val);
            },
            // 去掉中括号
            strFilte2 (val) {
                return val.substr(1, val.length - 2);
            },
            evaluationFilter (val) {
                const evaluationObj = JSON.parse(val);
                return evaluationObj.comment;
            },

            // 截取上报原因
            getReason (val) {
                var index = val.lastIndexOf('：');
                val = val.substring(index + 1, val.length);
                return val;
            },
            // 截取所上报中心
            strFilter (val) {
                try {
                    return util.getBracketSt(val)[1];
                } catch (err) {
                }
            },
            strFilter5 (val) {
              return util.getBracketSt(val)[0];
            },
            strFilter2 (val) {
                try {
                    return util.getBracketSt(val)[0];
                } catch (err) {
                }
            },
        },
        components: { review, accept },
        props: ['data', 'historyInfo', 'btnlist', 'addressInfo', 'flowid'],
        data () {
            return {
                feedbackButtonShow: false, // 控制反馈按钮显示
                contactPersonShow: false,
                supervisionCenterList: [], // 监理中心联系人列表
                userInfo: {
                    roleList: []
                },
                status: 0, // 退货单状态
                overseeList: [], // 督办列表
                appeal: {},
                timeDifference: 0, // 不予受理的操作时间与当前时间的时间差
                timer: null,
                evaluationList: [], // 评价列表
                protocol: '', // 协议连接
                typeValue: '',
                WHEREFORE: [] // 不予受理原因
            };
        },
        created () {
            this.getType()
            api.currentUser().then(res => {
                if (res.ret === 0) {
                    this.userInfo = res.data
                    this.getParentOrg();
                } else {
                    this.userInfo = {}
                }
            })
            if (this.$store.state.refund.detail.entrustment) {
                this.protocol = this.$store.state.refund.detail.entrustment.entrustmentUrl
            }
            console.log('协议连接', this.protocol)
            this.getDetail();
            this.status = this.data.status;
            // this.userInfo = JSON.parse(localStorage.getItem("refundUserInfo"));
            // 获取监理中心联系人列表
            this.getSupervisionCenterList();
            this.getTimeDifference();
            this.timer = setInterval(() => {
                this.timeDifference = this.timeDifference - 1000;
                this.showFEEDBACKEXPRESSBtn();
            }, 1 * 1000);
        },
        mounted () {
            try {
                const val = this.$refs.disposalProgress.offsetHeight;
                this.$emit('eleHeight', val);
            } catch (err) {
                console.log(err);
            }
        },
        beforeDestroy () {
            clearInterval(this.timer);
            this.timer = null;
        },
        beforeRouteLeave (to, from, next) {
            clearInterval(this.timer);
            this.timer = null;
        },
        methods: {
            // 撤销的补充说明
            cancellationInstructions () {
                if (this.historyInfo.length > 0) {
                    return this.historyInfo.find(i => i.optType === 150) ? this.historyInfo.find(i => i.optType === 150).memo : ''
                }
            },
            // 获取撤销原因
            ReasonRevocation () {
                let wherefore
                if (this.historyInfo.length > 0) {
                    if (this.historyInfo.find(i => i.optType === 150)) {
                        wherefore = this.historyInfo.find(i => i.optType === 150).wherefore
                    }
                }

                return this.WHEREFORE.find(i => i.code === wherefore) ? this.WHEREFORE.find(i => i.code === wherefore).name : ''
            },
            sendbackReason () {
                if (this.data.flowStatus < 400 && this.WHEREFORE.length > 0) {
                    const val = this.historyInfo[1].wherefore
                    return this.WHEREFORE.find(i => i.code === val) ? this.WHEREFORE.find(i => i.code === val).name : ''
                } else {
                    const val = this.historyInfo[0].wherefore
                    return this.WHEREFORE.find(i => i.code === val) ? this.WHEREFORE.find(i => i.code === val).name : ''
                }
            },
            // 是否退回商品
            isReturnGoods () {
                let a = false
                if (this.historyInfo.length > 0) {
                    const item = this.historyInfo.find(i => i.optType === 70)
                    a = (item.wherefore === 13) // wherefore为13时为退回商品
                }
                return a
            },

            // 反馈不予退款时获取原因
            FeedbackRefundable () {
                let reasonMsg = ''
                let reasonType
                const historyInfo = this.historyInfo
                if (historyInfo.length > 0) {
                    historyInfo.map(i => {
                        if (i.optType === 70) {
                            reasonType = i.wherefore
                        }
                    })
                }
                if (this.WHEREFORE.length > 0) {
                    this.WHEREFORE.map(i => {
                        if (i.code === reasonType) {
                            reasonMsg = i.name
                        }
                    })
                }
                return reasonMsg
            },
            getType () {
                api.typePicker().then(res => {
                    if (res.ret === 0 && res.data) {
                        if (res.data.WHEREFORE_ALL) {
                            this.WHEREFORE = res.data.WHEREFORE_ALL
                        }
                    }
                }).catch(err => {
                    console.log(err)
                })
            },
            // 获取不予受理原因
            getInadmissibleReason (history) {
                let txt = ''
                let item = {}
                if (history.length > 0) {
                    history.map(i => {
                        if (i.optText === '不予受理') {
                            item = i
                        }
                    })
                    if (item.wherefore) {
                        this.WHEREFORE.map(i => {
                            if (i.code === item.wherefore) {
                                txt = i.name
                            }
                        })
                    } else {
                        // const arr = item.optContent.split('】')
                        // txt = arr[arr.length - 1]
                    }
                }
                return txt
            },
            // 评价详情
            evaluationDetails () {
                this.$router.push({
                    path: '/refund/evaluationDetails',
                    query: {
                        flowId: this.data.flowId
                    }
                });
            },
            getEvaluation () {
                try {
                    let TXT
                    if (this.evaluationList && this.evaluationList.length > 0) {
                        const option = {
                            1: '不满意',
                            3: '基本满意',
                            5: '满意'
                        }
                        if (this.userInfo && ['Handler', 'leader', 'Leader'].includes(this.userInfo.roleList[0])) {
                            this.evaluationList.map((i, index) => {
                                if (i.targetType == 1) {
                                    TXT = option[i.grade]
                                }
                            })
                        } else if (this.userInfo && this.userInfo.roleList[0] == 'CenterHandler') {
                            // 如果是退货中心
                            this.evaluationList.map((i, index) => {
                                if (i.targetType == 3) {
                                    TXT = option[i.grade]
                                }
                            })
                        } else if (this.userInfo && this.userInfo.roleList[0] == 'CompanyHandler') {
                            // 如果是企业
                            this.evaluationList.map((i, index) => {
                                if (i.targetType == 4) {
                                    TXT = option[i.grade]
                                }
                            })
                        }
                    }
                    return TXT
                } catch (err) {
                    alert(err)
                }
            },
            getParentOrg () {
                if (this.userInfo && this.userInfo.regionType == '1') {

                } else {
                    api.getSelfParentOrg().then(res => {
                        if (res.ret === 0) {
                            this.typeValue = res.data.name
                        } else {
                            this.typeValue = ''
                        }
                    })
                }
                // api.parentOrg({ orgId: this.orgId }).then(res => {
                //   if (res.ret === 0) {
                //     if (res.data) {
                //       this.typeValue = res.data.name;
                //     } else {
                //       this.typeValue = ''
                //     }
                //   }
                // });
            },
            // 反馈取货信息
            feedbackPickupInformation () {
                this.$router.push({
                    path: '/refund/feedbackPickupInformation',
                    query: {
                        basicId: this.data.basicId
                    }
                });
            },
            // 签协议
            signAgreement () {
                // 如果为退货中心角色帮客户退货时，要求客户签协议，点击后显示反馈按钮，反馈取货信息
                // 如果角色为退货中心，点击签协议后显示反馈按钮
                api.sign({ basicId: this.data.basicId }).then(res => {
                    if (res.ret === 0) {
                        this.$Toast({
                            message: '签协议成功'
                        });
                        this.$emit('confirmReceipt');
                        // setTimeout(() => {
                        //     this.$router.replace({
                        //         path: '/refund/refundDetail',
                        //         query: {
                        //             flowId: this.data.flowId
                        //         }
                        //     });
                        // }, 1500);
                    } else {
                        this.$router.replace({
                            path: '/refund/refundDetail',
                            query: {
                                flowId: this.data.flowId
                            }
                        });
                    }
                });
            },
            // 用户评价
            getTouristEvaluation () {
                let txt = '';
                const option = {
                    1: '不满意',
                    3: '基本满意',
                    5: '满意'
                };
                this.evaluationList.map(item => {
                    if (item.targetType === 1) {
                        txt = option[item.grade];
                    }
                });
                return txt;
            },
            // 控制反馈处置结果之后反馈快递单号按钮的显示
            showFEEDBACKEXPRESSBtn () {
                try {
                    this.getTimeDifference();
                    let flag = false;
                    let feedBackType = ''; // 反馈类型
                    if (this.historyInfo && this.historyInfo.length > 0) {
                        feedBackType = this.historyInfo[0].optText
                    }
                    // 如果当前退货单的status是70且是不予受理，并且倒计时已经完成就显示反馈快递单号按钮
                    if (
                        this.data.status == 70 &&
                        feedBackType === '不予受理' &&
                        this.timeDifference < 0
                    ) {
                        flag = true;
                    } else {
                        flag = false;
                    }
                    return flag;
                } catch (err) {
                    console.log(err);
                }
            },
            // 获取不予受理与当前时间的时间差
            getTimeDifference () {
                // 获取当前时间的时间戳
                let currentTimestamp = new Date().getTime();
                let startTimestamp = 0;
                // 获取不予受理的操作时间
                // 如果退货单状态时直接不予受理之后
                if (this.status === 30) {
                    this.historyInfo.map(item => {
                        if (item.optType === 30) {
                            startTimestamp = item.creatTime;
                        }
                    });
                } else {
                    this.historyInfo.map(item => {
                        if (item.optType === 70) {
                            startTimestamp = item.creatTime;
                        }
                    });
                }
                const endTimestamp = startTimestamp + 43200000;
                this.timeDifference = endTimestamp - currentTimestamp;
            },
            // 获取退货单详情
            getDetail () {
                api.detailList({ flowId: this.flowid }).then(res => {
                    if (res.ret === 0) {
                        this.appeal = res.data.appeal;
                        this.evaluationList = res.data.evaluations;
                    }
                });
            },
            // 申诉反馈
            appealFeedback () {
                this.$router.push({
                    path: '/refund/appealFeedback',
                    query: {
                        data: this.data
                    }
                });
            },
            // 打开联系监理中心
            contactSupervisionCenter () {
                this.contactPersonShow = true;
            },
            // 上报审核
            review () {
                this.$router.push({
                    path: '/refund/reportReview',
                    query: {
                        data: this.data,
                        txt: this.historyInfo[2].optContent,
                        reason: this.historyInfo[2].optContent
                    }
                });
                // if (this.btnlist.includes("Has_REVIEW")) {
                //   this.$Toast({
                //     message: "已审核"
                //   });
                // } else {
                //   this.$refs.review.showBox();
                // }
            },
            // 处置结果审核
            disposalResultReview () {
                this.$router.push({
                    path: '/refund/disposalResultReview',
                    query: {
                        data: this.data
                    }
                });
            },
            // 申诉反馈审核
            appealFeedbackReview () {
                this.$router.push({
                    path: '/refund/appealFeedbackReview',
                    query: {
                        data: this.data
                    }
                });
            },
            // 审核通过
            sendReview () {
                // 审核通过
                api
                    .audit({ flowId: this.data.flowId, status: '22', content: '' })
                    .then(res => {
                        if (res.ret === 0) {
                            this.$Toast({
                                message: res.msg
                            });
                            setTimeout(() => {
                                this.$router.replace({
                                    path: '/refund/refundDetail',
                                    query: {
                                        flowId: this.data.flowId
                                    }
                                });
                            }, 1500);
                        }
                    });
            },
            // 反馈退货地址
            feedbackAddress () {
                this.$router.push({
                    path: '/refund/feedbackAddress',
                    query: {
                        flowId: this.flowid
                    }
                });
            },
            // 上传快递单号
            UploadTrackingNumber () {
                this.$router.push({
                    path: '/refund/express',
                    query: {
                        number: this.data.orderNumber,
                        flowId: this.flowid
                    }
                });
            },
            // 查看物流
            checkLogistics () {
                this.$router.push({
                    path: '/refund/logistics',
                    query: {
                        data: this.data,
                        addressInfo: this.addressInfo
                    }
                });
            },
            // 获取监理中心联系人
            getSupervisionCenterList () {
                const param = {
                    regionCode: this.data.cityId,
                    pageIndex: 1,
                    pageSize: 10
                };
                api.getHandlerByRegionCode(param).then(res => {
                    if (res.ret === 0) {
                        this.supervisionCenterList = res.data.userDtoList;
                        if (
                            this.supervisionCenterList &&
                            this.supervisionCenterList.length > 0
                        ) {
                            this.supervisionCenterList.map(item => {
                                item.vagueMobile =
                                    item.mobile.substr(0, 4) + ' **** ' + item.mobile.substr(7);
                            });
                        }
                    } else {
                        this.supervisionCenterList = [];
                    }
                });
            },
            // 反馈
            feedback () {
                // this.$router.push({
                //   path: "/refund/feedReulst",
                //   query: {
                //     number: this.data.orderNumber,
                //     flowid: this.flowid,
                //     price: this.data.shoppingAmount
                //   }
                // });
                this.$router.push({
                    path: '/refund/feedbackDisposalResults',
                    query: {
                        data: this.data,
                        flowid: this.flowid
                    }
                });
            },
            // 点击确认收货
            receipt () {
                try {
                    // this.$refs.accept.showBox();
                    Dialog.confirm({
                        title: '是否确认收货？',
                        message: '请收到商品后确认无误再确认收货',
                        confirmButtonColor: '#36B374'
                    })
                        .then(() => {
                            // on confirm
                            this.sendAccept()
                        })
                        .catch(() => {
                            // on cancel
                        });
                } catch (err) {
                    alert(err);
                }
            },
            // 确认收货回调
            sendAccept () {
                try {
                    api.confirmReceipt({ flowId: this.flowid }).then(res => {
                        if (res.ret === 0) {
                            this.$Toast({
                                message: '收货成功'
                            });
                            this.$emit('confirmReceipt');
                            // setTimeout(() => {
                            //   this.$router.replace({
                            //     path: "/refund/refundDetail",
                            //     query: {
                            //       flowId: this.data.flowId
                            //     }
                            //   });
                            // }, 1500);
                        } else {
                            this.$Toast({
                                message: res.msg
                            });
                        }
                    });
                } catch (err) {
                    alert(err);
                }
            },

            // 查看处置进度
            checkProgress () {
                this.$router.push({
                    path: '/refund/disposalProgressDetail',
                    query: {
                        historyInfo: JSON.stringify(this.historyInfo),
                        flowid: this.flowid,
                        detailInfo: JSON.stringify(this.data)
                    }
                });
            }
        }
    };
</script>

<style lang="less" scoped>
.disposal-progress-box {
  width: 100%;
  // position: fixed;
  z-index: 3;
  left: 0;
  // padding: 0 14px;
  top: 79px;
  .disposal-progress-inner {
    position: relative;
    background: #ebfaf1;
    min-height: 95px;
    padding: 16px;
    padding-bottom: 20px;
    font-size: 12px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border-radius: 4px;
    .bg {
      width: 81px;
      height: 62px;
      position: absolute;
      top: 16px;
      right: 16px;
    }
    .header {
      z-index: 1;
      .title {
        font-family: PingFangSC-Semibold;
        font-size: 20px;
        color: #36b374;
        letter-spacing: 0;
        line-height: 20px;
        font-weight: 600;
      }
      .content-item {
        font-size: 14px;
        color: #333333;
        line-height: 20px;
        font-weight: 400;
    
       
        .shenhezhong {
          font-weight: 400;
          font-size: 14px;
          color: #666666;
          letter-spacing: 0;
          line-height: 14px;
        }
        .centerName {
          font-weight: 400;
          font-size: 14px;
          color: #333333;
        }
        img {
          width: 16px;
          height: 16px;
          vertical-align: sub;
          display: inline-block;
        }
        .sign {
          font-size: 14px;
          color: #36b374;
          font-weight: 400;
        }
        span {
          font-size: 14px;
          color: #333333;
          font-weight: 400;
        }
        .fontweight-span {
          color: #666666;
          font-weight: 500;
        }
        .color333333 {
          color: #333333;
        }
        .protocol-link {
          color: #8cd1ab;
        }
        &:first-child {
          margin-top: 10px;
        }
        &:not(:first-child) {
          margin-top: 6px;
        }
      }
      .color666 {
        color: #666666;
      }
      .buyushouliyuanyin {
          font-weight: 400;
          font-size: 14px;
          color: #333333;
        }
    }
    .foot {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 13px;
      .see-progress {
        color: #71747a;
        font-size: 12px;
        font-weight: 400;
        display: flex;
        align-items: center;
        .van-icon-arrow:before {
          font-size: 12px;
        }
        .van-icon {
          vertical-align: top;
          margin-left: 2px;
        }
      }
      .btn-box {
        display: flex;
        z-index: 1;
        .btn-active {
          background: #36b374;
          color: #ffffff;
          border: 1px solid #36b374;
          text-align: center;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .btn {
          border-color: #36b374;
          color: #36b374;
          text-align: center;
          border: 1px solid #36b374;
        }
        div {
          margin-left: 8px;
          border-radius: 4px;
          padding: 0 13px;
          line-height: 28px;
        }
      }
    }
  }
}
.popup {
  padding: 20px 16px;
  .title {
    font-size: 16px;
    color: #171a1d;
    line-height: 16px;
    font-weight: 600;
    margin-bottom: 20px;
  }
  /deep/.contact-list {
    max-height: 330px;
    overflow-y: auto;
    padding-bottom: 50px;
    .van-icon-cross::before {
      content: "";
      width: 16px;
      height: 16px;
      background-image: url("../../../../assets/refund/down.png");
      background-size: 100% 100%;
    }
    &::-webkit-scrollbar {
      display: none;
    }
    .contact-item {
      padding: 15px 0;
      border-bottom: 1px solid #f5f6f9;
      display: flex;
      justify-content: space-between;
      .contact-info {
        display: flex;
        .Contact-avatar {
          width: 38px;
          height: 38px;
          margin-right: 12px;
        }
        .business-card {
          background: #36b374;
          border-radius: 4px;
          font-size: 20px;
          color: #ffffff;
          padding: 8px;
          margin-right: 13px;
        }
        .person-info {
          display: flex;
          justify-content: space-between;
          flex-direction: column;
          .contact-name {
            font-size: 16px;
            color: #171a1d;
            letter-spacing: 0;
            line-height: 16px;
          }
          .phone {
            font-size: 14px;
            color: #71747a;
            letter-spacing: 0;
            line-height: 14px;
          }
        }
      }
      .call {
        background-color: #eaf7f1;
        width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: space-around;
        border-radius: 50%;
        .call-icon {
          width: 16px;
          height: 16px;
          background-image: url("../../../../assets/refund/call-icon.png");
          background-size: 100% 100%;
        }
      }
    }
  }
}
</style>
